// 绝对时间格式化：YYYY-MM-DD HH:mm。
// 用平台内置 Intl（浏览器 / Node 皆有，零依赖）解析并按「运行时本地时区」换算；
// 不传 timeZone 即跟随用户浏览器时区。用 formatToParts 自己拼装，锁死格式不受系统 locale 影响；
// hourCycle 'h23' 保证 00–23（规避部分引擎 hour12:false 出 '24:00' 的怪相）。
export const formatDateTime = (date: Date): string => {
  const parts = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date)
  const pick = (type: Intl.DateTimeFormatPartTypes): string => parts.find(p => p.type === type)?.value ?? ''
  return `${pick('year')}-${pick('month')}-${pick('day')} ${pick('hour')}:${pick('minute')}`
}
